export const BASE_AUTH_SUBURL = "/auth/";
export const BASE_DOC_SUBURL = "/doctor/";
export const BASE_PAT_SUBURL = "/patient/";
export const BASE_PAY_SUBURL = "/payment/";
export const BASE_CALE_SUBURL = "/calendar/";
export const BASE_MEDSTUDIO_SUBURL = "/medical-studio/";
export const BASE_ITASK_SUBURL = "/itask/";
export const BASE_POSTURAL_EXAMINATION_SUBURL = "/postural-examination/";
export const BASE_POSTURAL_EXAMINATION_DEF_SUBURL =
  "/postural-examination-definition/";

export const LOGIN_PATH = "/login";
export const REGISTER_PATH = "/iscrizione";
export const HOME_PATH = "/home";
export const ADMIN_PATH = "/geisha_panel";
export const APPOINTMENTS_PATH = "/appointments";
export const ADMIN_HOME_PATH = "/geisha_home";
export const PATIENTS_PATH = "/patients";
export const PDF_EXAMS_PATH = "/pdf-exams";
export const COMPARE_EXAMS_PATH = "/compare-exams";
export const DOC_PATH = "/doctor";
export const PRICE_PATH = "/price";
